import React from 'react'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://b73c242771644ad0917001ef76eb7e9b@o201646.ingest.sentry.io/1314479",
  enabled: false, //window.location.hostname != "localhost",
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay()
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^\//],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  sendClientReports: false
});

const Fallback = ({ error, componentStack, resetError }) => {
  return <div className={"alert alert-warning"} style={{padding: "1.5rem;"}}>
    <h1>{error.toString()}</h1>
    <hr/>
    <strong>Stacktrace:</strong>
    <pre>
      <code>
        {componentStack}
      </code>
    </pre>

    <div className="d-grid gap-2">
      <div
        onClick={() => window.location.reload()}
        className="btn btn-primary btn-lg rounded-0">
        RELOAD PAGE
      </div>
    </div>
  </div>
}

const ErrorBoundary = ({children}) => {
  return <Sentry.ErrorBoundary fallback={Fallback}>
    {children}
  </Sentry.ErrorBoundary>
}

export default ErrorBoundary
